import { Currency } from '@/core/currency/interfaces';

const VND: Currency = {
    name: 'Vietnamese Dong',
    demonym: 'Vietnamese',
    majorSingle: 'Dong',
    majorPlural: 'Dong',
    codeNumeric: '704',
    symbol: '₫',
    symbolNative: '₫',
    minorSingle: 'Hào',
    minorPlural: 'Hào',
    ISOdigits: 0,
    decimals: 0,
    numToBasic: 10,
    code: 'VND',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default VND;
